import { apiSlice } from '../app/api/apiSlice';

export const feedbackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeedbacks: builder.query({
      query: ({ page = 1, limit = 10, search = '', form_name = 'post_purchase' } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (search) params.append('search', search);
        if (form_name) params.append('form_name', form_name);

        return {
          url: `feedback/by-form-name${params.toString() ? `?${params.toString()}` : ''}`,
        };
      },
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
  }),
});

export const { useGetFeedbacksQuery, useLazyGetFeedbacksQuery } = feedbackApiSlice;
